<template lang="pug">
  .merklisten
    .wrap
      .metanav
        .left
          router-link(:to="{ name: 'home' }") {{ $t(`Zurück zur Fundus Übersicht`) }}
          strong  {{ $t(`Merkliste verwalten`) }}
        //-.right 
          a(href="https://www.fundus.berlin/profil/") Benutzerdaten
    .wrap
      #merklisten
        new-list-tile
        template(v-for="list in wishlists")
          transition(name="fade" mode="in-out")
            merkliste-tile(:list="list")
</template>

<script>
import NewListTile from '@/components/NewListTile.vue'
import MerklisteTile from '@/components/MerklisteTile.vue'
export default {
  name: 'Merklisten',
  metaInfo () {
    return {
      title: 'Merklisten verwalten'
    }
  },
  data: () => ({
  }),
  components: {
    NewListTile,
    MerklisteTile
  },
  computed: {
    wishlists: {
      get () {
        return this.$store.state.wishlists
      }
    }
  },
  mounted () {
    window._paq.push(['setCustomUrl', window.location])
    window._paq.push(['setDocumentTitle', this.$metaInfo.title])
    window._paq.push(['trackPageView'])
  }
}
</script>

<style scoped lang="sass">
@media only screen and (max-width: 600px)
  .newlist
    position: relative
    margin-bottom: 30px
  .liste
    margin-bottom: 0
.liste
  box-sizing: content-box
@media only screen and (min-width: 600px)
  .liste:nth-child(2)
    margin-left: 270px
</style>
